import { Card } from '@bb/elements-web';
import styled from 'styled-components';
import React from 'react';
import DocumentsCardBase from '../../../BillingInvoicesPage/components/DocumentsCard';
import { useSubscriptionsPageContext } from '../../SubscriptionsPageContext';

/**
 * DocumentsCard for SubscriptionsPaymentsPage
 *
 * This component wraps the existing DocumentsCard from BillingInvoicesPage
 * with custom styling for the new Subscriptions UI.
 *
 * TODO: When the subscriptionHubFeature flag is fully rolled ou (KB-1656) and
 * BillingInvoicesPage is deprecated, merge this styling into the original
 * DocumentsCard component and remove this wrapper.
 *
 * @see BillingInvoicesPage/components/DocumentsCard - Original component
 */
const DocumentsCard: React.FC = () => {
  const { billingCustomerNumber } = useSubscriptionsPageContext();
  return (
    <DocumentsCardBase
      userBillingNumber={billingCustomerNumber}
      CardComponent={StyledCard}
    />
  );
};

export default DocumentsCard;

const StyledCard = styled(Card)`
  /* Card title styling */
  .ant-card-head-title {
    font-size: 20px;
    font-weight: 500;
    color: #1a1b21;
  }

  /* Remove horizontal divider under title */
  .ant-card-head {
    border-bottom: none;
  }

  /* Card body padding */
  .ant-card-body {
    padding: 0 24px 24px 24px;
  }

  /* Column header styling */
  .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: 500;
    padding: 12px 16px;
  }

  /* Table cell styling */
  .ant-table-tbody > tr > td {
    font-size: 14px;
  }
`;
